<template>
	<c-modal @close="close" :title="edit ? 'Wijzig ' + clientType : 'Nieuwe ' + clientType">

		<c-form ref="form" @valid="submit">
			<div v-if="!edit && user.contact">
				<div class="margin-t-40">
					<c-select
						:horizontal="true"
						:label="'Rol'"
						:options="clientTypes()"
						:required="true"
						v-model="client_type_id"
						name="client_type_id"
						:DisplayName="'name'"
						:ValueName="'id'"
					/>
				</div>

				<div class="margin-t-40" v-if="client_type_id == $constants.client.EINDKLANT">
					<c-select
						:horizontal="true"
						:label="'Reseller'"
						:options="resellers"
						v-model="parent_client_id"
						name="parent_client_id"
						:DisplayName="'name'"
						:ValueName="'id'"
					/>
				</div>
			</div>

			<c-form-new-reseller-end-customer
                ref="modalform"
                v-if="client_type_id == $constants.client.RESELLER || client_type_id == $constants.client.REUZADO"
                :edit="edit"
                :client="client"
                :client_type_id="client_type_id"
            />

			<c-form-new-reseller-end-customer
                ref="modalform"
                v-if="client_type_id == $constants.client.EINDKLANT"
                :client="client"
                :edit="edit"
                :client_type_id="client_type_id"
            />

			<c-form-new-end-user
                ref="modalform"
                v-if="client_type_id == $constants.client.EINDGEBRUIKER"
                :contact="client"
                :edit="edit" />

			<div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">{{edit ?  clientType +" wijzigen" : clientType + " toevoegen"}}</c-button>
				</div>
			</div>
		</c-form>

	</c-modal>
</template>

<script>

import Form from '@mixins/Form';
import CModal from '@components/Modal';
import CFormNewResellerEndCustomer from '@forms/NewResellerEndCustomer';
import CFormNewEndUser from '@forms/NewEndUser';
import { mapGetters } from 'vuex';
import { ValidationError } from '../errors';

export default {
	mixins: [Form],
	components: {
		CModal, CFormNewResellerEndCustomer, CFormNewEndUser
	},
	data() {
		return {
			parent_client_id: '',
			resellers: '',
		};
	},
	props: {
		edit: {
			required: false,
			default: false
		},
		client: {
			required: false,
			default: []
		},
		title: {
			default: 'Nieuwe',
		},
		client_type_id: {
			default: "4"
		}
	},
	computed: {
		...mapGetters({
			user: 'user/get'
		}),
        clientType(){
            return this.$constants.getClientTypeWithId(this.client_type_id)
        }
	},
	methods: {
		clientTypes(){
			let clientTypes = [];
			if(this.user.contact.client.client_type_id == this.$constants.client.REUZADO)
			{
				clientTypes = [
					{
						id: '2',
						name: 'Reseller'
					},
					{
						id: '3',
						name: 'Eindklant'
					},
					{
						id: '4',
						name: 'Eindgebruiker'
					}
				]
			}
			else if(this.user.contact.client.client_type_id == this.$constants.client.RESELLER)
			{
				clientTypes = [
					{
						id: '3',
						name: 'Eindklant'
					},
					{
						id: '4',
						name: 'Eindgebruiker'
					}
				]
			}
			else
			{
				clientTypes = [
					{
						id: '4',
						name: 'Eindgebruiker'
					}
				]
			}

			return clientTypes;
		},
		close() {
			this.$emit('close');
		},
        updateContacts(contacts){
            this.client.contacts = contacts;
        },
		submit() {

			let client_type_id = {
				client_type_id: this.client_type_id
			}

			let Formdata = this.$refs.modalform.getData();

			let data = "";
			if(this.client_type_id == this.$constants.client.EINDKLANT && !this.edit)
			{
				let parent_client_id = {
					parent_client_id: this.parent_client_id,
					invoice_description: Formdata.invoice_description,
					invoice_reference: Formdata.invoice_reference
				}

				data = Object.assign(Formdata, client_type_id, parent_client_id);
			}
			else if(this.edit && this.client_type_id == this.$constants.client.EINDGEBRUIKER){
				data = {
					first_name:Formdata.contacts[0].first_name,
                    last_name: Formdata.contacts[0].last_name,
					phone: Formdata.contacts[0].phone,
					email: Formdata.contacts[0].email,
					has_account: Formdata.contacts[0].has_account,
					id: Formdata.contacts[0].id,
				}
			}
			else if (this.edit ){
				data = {
					client_type_id: this.client_type_id,
                    primary_contact_id: Formdata.primary_contact_id,
					name: Formdata.name,
					image: Formdata.image,
					invoice_description: Formdata.invoice_description,
					invoice_reference: Formdata.invoice_reference,
					client_id: this.client.id,
					zipcode: Formdata.addresses[0].zipcode,
					number: Formdata.addresses[0].number,
					street: Formdata.addresses[0].street,
					city: Formdata.addresses[0].city,
					addition: Formdata.addresses[0].addition,
					country: Formdata.addresses[0].country
				}
			}
			else
			{
				data = Object.assign(Formdata, client_type_id);
			}

			const filterEmpty = function f(data) {
				for (const k in data) {
					if (data[k] instanceof Object && data[k]) {
						f(data[k]);
					}
					if (data[k] === null || data[k] === undefined) {
						delete data[k];
					}
				}
			}
			filterEmpty(data);
			if(this.edit)
			{
				if(this.client_type_id == this.$constants.client.EINDGEBRUIKER ){
					data._method = 'PUT';
					this.$xhr.put('/api/contacts/'+ data.id, data).then( ( {result}) => {
						this.$store.dispatch('toast/success', {title: 'Contactpersoon wijzigen', text: 'De contactpersoon is gewijzigd'});
						this.close();
						this.$emit('added');
                	}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
                    this.$store.dispatch('toast/alert', {title: 'Contactpersoon aanmaken', text: 'Er is helaas iets fout gegaan bij het wijzigen van de contactpersoon'});
                });

				}
				else {
					data._method = 'PUT';
					this.$xhr.post('/api/clients/' + this.client.id, data).then( ( {result}) => {
						this.$store.dispatch('toast/success', {title: 'Contactpersoon aanpassen', text: 'De contactpersoon is aangepast'});
						this.close();
						this.$emit('added');
					}).catch( (e) => {
						if(e instanceof ValidationError) {
							let errors = {
								contacts: []
							};
							errors['contacts'][0] = e.errors;
							this.$refs.form.setErrors(errors);
							this.$refs.form.setErrors(e.errors);
						};
						this.$store.dispatch('toast/alert', {title: 'Contactpersoon aanpassen', text: 'Er is helaas iets fout gegaan bij het aanpassen van de contactpersoon'});
					});
				}
			}
			else if(this.client_type_id == this.$constants.client.EINDGEBRUIKER && Formdata.items.length === 0){
				this.$store.dispatch('toast/alert', {title: 'Gebruiker aanmaken', text: 'Het is niet mogelijk een gebruiker aan te maken zonder voorraad'});
			}
			else
			{
				this.$store.dispatch('user/store', {
					data
				}).then(() => {
					this.$store.dispatch('toast/success', { title: 'Gebruiker aanmaken', text: 'De gebruiker is aangemaakt' });
					this.$refs.form.reset();
					this.close();
					this.$refs.modalform.clear();
					this.$emit('added');
					this.parent_client_id = '';
				}).catch( (e) => {
					if(e instanceof ValidationError) {
						this.$refs.form.setErrors(e.errors);
					};
					this.$store.dispatch('toast/alert', {title: 'Gebruiker aanmaken', text: 'Er is helaas iets fout gegaan bij het aanmaken van de gebruiker'});
				});
			}

		},
	},
	mounted() {
		this.$xhr.get('/api/getallresellers').then( ( {result}) => {
				this.resellers = result;
				if(this.resellers.length == 1){
					this.parent_client_id = this.resellers[0].id;
				}
			}).catch( (e) => {
		});
    },
}
</script>
